export default __webpack_public_path__ + "static/media/test1.353451d1.jpg";